import { UseQueryStateResult } from '@reduxjs/toolkit/dist/query/react/buildHooks.d'
import { createApi } from '@reduxjs/toolkit/query/react'

import { API_VERSION_3, PER_PAGE } from '@store/constants'

import baseQueryInterceptor from '@api/base-query-interceptor'
import { ApiResponse } from '@api/types/api-response.type'

import { getUserEmail } from '@utilities/helper'

import { Status } from '@adUtilities/constants'

export interface ProjectListDetails {
  id: string
  name: string
  canonicalName: string
  uuid: string
}

interface ProjectListParams {
  page: number
  query: string
}

interface ProjectListApiResult {
  list: ProjectListDetails[]
  lastPage: number
  isLoaded: boolean
  isError: boolean
  status: string
  errorStatus: number
}

export const projectListApi = createApi({
  reducerPath: 'projectListApi',
  baseQuery: baseQueryInterceptor,
  endpoints: (builder) => ({
    getProjectList: builder.query<
      ApiResponse<Array<ProjectListDetails>>,
      ProjectListParams
    >({
      query: (params: ProjectListParams) => ({
        url: `/${API_VERSION_3}/projects/list?user_name=${getUserEmail()}`,
        method: 'get',
        params: {
          page: params.page,
          search: params.query,
          per_page: PER_PAGE,
          status: Status.Available,
        },
      }),
    }),
  }),
})

export const selectFromResult = ({
  status,
  data,
  error,
  isError,
  isLoading,
}: UseQueryStateResult<any, any>): ProjectListApiResult => ({
  list: data?.data?.data || [],
  lastPage: data?.data?.last_page || 1,
  isLoaded: !isLoading,
  isError,
  status,
  errorStatus: error?.status,
})

export const { useGetProjectListQuery } = projectListApi
